document.addEventListener('DOMContentLoaded', () => {
  const year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

  const header = document.querySelector('.site-header');
  const nav = document.querySelector('.nav');
  const links = document.querySelector('.nav-links');

  if (header) {
    const headerShell = header.closest('.shopify-section') || header;
    headerShell.classList.add('sticky-header-shell');
    let compact = false;
    const updateHeaderState = () => {
      if (!compact && window.scrollY > 80) compact = true;
      if (compact && window.scrollY < 8) compact = false;

      header.classList.toggle('is-scrolled', compact);
      headerShell.classList.toggle('is-scrolled', compact);
    };

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  if (nav && links) {
    if (!links.id) links.id = 'primary-menu';

    let toggle = nav.querySelector('.menu-toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.className = 'menu-toggle';
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', links.id);
      toggle.innerHTML = '<span></span><span></span><span></span><span class="sr-only">Menu</span>';

      const actions = nav.querySelector('.nav-actions');
      nav.insertBefore(toggle, actions || links);
    }

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      links.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });

    links.querySelectorAll('a').forEach((anchor) => {
      anchor.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false');
        links.classList.remove('is-open');
        document.body.classList.remove('menu-open');
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 860) {
        toggle.setAttribute('aria-expanded', 'false');
        links.classList.remove('is-open');
        document.body.classList.remove('menu-open');
      }
    });
  }

  if (window.anime) {
    anime({
      targets: '.reveal',
      translateY: [22, 0],
      opacity: [0, 1],
      delay: anime.stagger(80, { start: 160 }),
      duration: 900,
      easing: 'easeOutCubic',
    });

    anime({
      targets: '.botanical-float',
      rotate: [-1.5, 1.5],
      direction: 'alternate',
      loop: true,
      duration: 6800,
      easing: 'easeInOutSine',
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    if (!track || slides.length < 2) return;

    let currentIndex = 0;

    const setActive = (index) => {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === currentIndex);
        thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActive(Number(thumb.dataset.galleryThumb || 0)));
    });

    if (prev) {
      prev.addEventListener('click', () => setActive(currentIndex === 0 ? slides.length - 1 : currentIndex - 1));
    }

    if (next) {
      next.addEventListener('click', () => setActive(currentIndex === slides.length - 1 ? 0 : currentIndex + 1));
    }

    track.addEventListener(
      'scroll',
      () => {
        const nextIndex = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (nextIndex === currentIndex) return;
        currentIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
        thumbs.forEach((thumb, thumbIndex) => {
          thumb.classList.toggle('is-active', thumbIndex === currentIndex);
          thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
        });
      },
      { passive: true }
    );
  });

  const getCartRoutes = () => {
    const root = window.Shopify?.routes?.root || '/';
    return {
      add: `${root}cart/add.js`,
      cart: `${root}cart`,
      cartJson: `${root}cart.js`,
      checkout: `${root}checkout`,
      collections: `${root}collections/all`,
    };
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return entities[character];
    });

  const getCartNotification = () => {
    let notification = document.querySelector('[data-cart-notification]');
    if (notification) return notification;

    notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.setAttribute('data-cart-notification', '');
    notification.setAttribute('role', 'status');
    notification.setAttribute('aria-live', 'polite');
    notification.innerHTML = `
      <button class="cart-notification-close" type="button" aria-label="Close cart notification">×</button>
      <div class="cart-notification-content" data-cart-notification-content></div>
    `;
    document.body.appendChild(notification);
    notification.querySelector('.cart-notification-close').addEventListener('click', () => {
      notification.classList.remove('is-open');
    });
    return notification;
  };

  const updateCartCount = (count = 0) => {
    document.querySelectorAll('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = String(count);
      bubble.classList.toggle('is-empty', count === 0);
      bubble.classList.add('is-updated');
      window.setTimeout(() => bubble.classList.remove('is-updated'), 260);
    });
  };

  const showCartNotification = (item, cart) => {
    const routes = getCartRoutes();
    const notification = getCartNotification();
    const content = notification.querySelector('[data-cart-notification-content]');
    const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '';
    const count = cart?.item_count || 0;
    const title = escapeHtml(item.product_title || item.title || 'Item');
    const variant = escapeHtml(item.variant_title || '');

    content.innerHTML = `
      <div class="cart-notification-header">
        <strong>Added to cart</strong>
        <span>${count} ${count === 1 ? 'item' : 'items'}</span>
      </div>
      <div class="cart-notification-item">
        <div class="cart-notification-image">${image}</div>
        <div>
          <p>${title}</p>
          ${variant ? `<small>${variant}</small>` : ''}
        </div>
      </div>
      <div class="cart-notification-actions">
        <a class="btn primary" href="${routes.cart}">View cart</a>
        <a class="btn soft" href="${routes.checkout}">Checkout</a>
        <button class="btn soft" type="button" data-continue-shopping>Continue shopping</button>
      </div>
    `;

    content.querySelector('[data-continue-shopping]')?.addEventListener('click', () => {
      notification.classList.remove('is-open');
    });

    notification.classList.add('is-open');
    updateCartCount(count);
    window.clearTimeout(notification._hideTimer);
    notification._hideTimer = window.setTimeout(() => {
      notification.classList.remove('is-open');
    }, 6500);
  };

  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
    const variantSelect = form.querySelector('select[name="id"]');
    const submitButton = form.querySelector('.product-form__submit');
    const submitText = submitButton?.querySelector('span');

    if (!submitButton || !submitText) return;

    const updateSubmitState = () => {
      if (!variantSelect) return;
      const selectedOption = variantSelect.selectedOptions[0];
      const available = selectedOption?.dataset.available === 'true';
      const preorder = selectedOption?.dataset.preorder === 'true';
      const addLabel = submitButton.dataset.addLabel || 'Add to Cart';
      const preorderLabel = submitButton.dataset.preorderLabel || 'Pre-order';
      const soldLabel = submitButton.dataset.soldLabel || 'Sold Out';

      submitButton.disabled = !available;
      submitButton.dataset.preorder = String(preorder);
      submitText.textContent = available ? (preorder ? preorderLabel : addLabel) : soldLabel;
    };

    variantSelect?.addEventListener('change', updateSubmitState);
    updateSubmitState();

    form.addEventListener('submit', async (event) => {
      if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;
      event.preventDefault();

      const routes = getCartRoutes();
      const originalText = submitText.textContent;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('is-loading');
      submitText.textContent = 'Adding...';

      try {
        const response = await fetch(routes.add, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });

        const item = await response.json();
        if (!response.ok) throw new Error(item.description || 'Unable to add item to cart.');

        const cart = await fetch(routes.cartJson, { headers: { Accept: 'application/json' } }).then((cartResponse) =>
          cartResponse.json()
        );
        
        const openedDrawer = window.AnishCartDrawer ? await window.AnishCartDrawer.handleAdded(cart) : false;
        if (!openedDrawer) showCartNotification(item, cart);
        submitText.textContent = 'Added';
        window.setTimeout(() => {
          submitText.textContent = originalText;
        }, 1200);
      } catch (error) {
        submitText.textContent = error.message || 'Unable to add';
        window.setTimeout(() => {
          submitText.textContent = originalText;
        }, 2400);
      } finally {
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('aria-disabled');
      }
    });
  });

  document.querySelectorAll('.product-card').forEach((card) => {
    if (!matchMedia('(pointer:fine)').matches) return;

    card.addEventListener('mousemove', (event) => {
      const rect = card.getBoundingClientRect();
      card.style.transform = `translateY(-7px) rotateX(${-(event.clientY - rect.top - rect.height / 2) / 45}deg) rotateY(${(event.clientX - rect.left - rect.width / 2) / 45}deg)`;
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
});
